import { useEffect } from "react";
import { InstantDb } from "../zustand/instant.schema";
import { chatState, userStore } from "../zustand";

export function useLastMessageForRoom(roomId) {
    return InstantDb.useQuery({
        messages: {
            $: {
                where: { roomId },
                order: { createdAt: 'desc' },
                limit: 1
            }
        }
    });
}

export function useAdminRoomManager() {
    const user = userStore((state) => state.user);
    const searchDms = chatState((state) => state.searchDms);

    const { isLoading, error, data } = InstantDb.useQuery({
        rooms: {
            user: {},
            $: {
                order: {
                    lastActive: 'desc',
                },
                where: {
                    type: 'user',
                    ...(searchDms && {
                        name: { $ilike: `%${searchDms}%` },
                    })
                }
            },
            msgs: {
                $: {
                    where: {
                        isRead: false,
                        senderType: { $not: `admin` }
                    }
                }
            }
        }
    });

    const { data: userUnread, error: userUnreadError } = InstantDb.useQuery({
        messages: {
            $: {
                where: {
                    isRead: false,
                    sender: { $not: `${user?.id}` },
                    'room.type': 'user',
                },
            },
        }
    });
    const { data: projectUnread, error: projectUnreadError } = InstantDb.useQuery({
        messages: {
            $: {
                where: {
                    isRead: false,
                    sender: { $not: `${user?.id}` },
                    'room.type': 'project',
                },
            },
        }
    });

    useEffect(() => {
        if (error) {
            console.error('Error in admin room manager: ', error);
        }
        if (userUnreadError) {
            console.error('Error in admin room manager: ', userUnreadError);
        }
        if (projectUnreadError) {
            console.error('Error in admin room manager: ', projectUnreadError);
        }
    }, [error, userUnreadError, projectUnreadError]);

    return {
        rooms: data?.rooms,
        isLoading,
        unread: userUnread,
        projectUnread: projectUnread
    }
}